export const endpoints = {
    citationBackend: process.env.REACT_APP_CITATION_BACKEND,
}